export class Conciliacion {
   emisorId: string;
   dateString: string;
   usuarioId: string;
   sucursalId: string;
   mensual: boolean;
}
